import*as e from"react";const i=e.createContext({owner:void 0,uuid:"",index:"0",deviceType:"COUNTER",NodePicker:void 0,lineNodes:[],deviceLineId:void 0});export{i as DeviceContext};
//# sourceMappingURL=device.js.map
